module.exports = __webpack_public_path__ + "h5/img/flower_3_3.f60a2131.svg";